import React, { type ComponentType } from "react";
import type { UserResource } from "@exonn/js-sdk";
import { useUser } from "src/auth/auth.ts";

type ValidLoggedInProps = { user: UserResource };
type ValidLoggedOutProps = Record<string, any>;
type ValidLoadingProps = Record<string, any>;

export type ResolveAuthStateProps<
  LoggedInProps extends ValidLoggedInProps = ValidLoggedInProps,
  LoggedOutProps extends ValidLoggedOutProps = ValidLoggedOutProps,
  LoadingProps extends ValidLoadingProps = ValidLoadingProps,
> = {
  LoggedIn?: ComponentType<LoggedInProps>;
  Loading?: ComponentType<LoadingProps>;
  LoggedOut?: ComponentType<LoggedOutProps>;
  loggedInProps?: Omit<LoggedInProps, "user">;
  loggedOutProps?: LoggedOutProps;
  loadingProps?: LoadingProps;
};

export const ResolveAuthState = <
  LoggedInProps extends ValidLoggedInProps = ValidLoggedInProps,
  LoggedOutProps extends ValidLoggedOutProps = ValidLoggedOutProps,
  LoadingProps extends ValidLoadingProps = ValidLoadingProps,
>({
  LoggedIn,
  Loading,
  LoggedOut,
  loggedInProps,
  loggedOutProps,
  loadingProps,
}: ResolveAuthStateProps<LoggedInProps, LoggedOutProps, LoadingProps>) => {
  const { data: user, isLoading: isUserLoading } = useUser();
  if (user && LoggedIn) {
    // ignoring this issue https://github.com/emotion-js/emotion/issues/3261
    // @ts-ignore
    return <LoggedIn user={user} {...loggedInProps} />;
  }
  if (isUserLoading && Loading) {
    // @ts-ignore
    return <Loading {...loadingProps} />;
  }
  if (LoggedOut) {
    // @ts-ignore
    return <LoggedOut {...loggedOutProps} />;
  }
  return null;
};
